import {
  STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK,
  STORAGE_KEY_ACCESS_TOKEN_WSO2,
  STORAGE_KEY_ID_PERFIL,
} from "./../../storageCore/constStorageKeys";
import { environment } from "src/environments/environment";
import { Observable } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import storageX from "src/app/storageCore/storageX";

@Injectable({
  providedIn: "root",
})
export class CockpitService {
  constructor(private http: HttpClient) {}

  private buildAuthHeaders(): Record<string, string> {
    const headers: Record<string, string> = {
      "Content-Type": "application/json",
      Authorization:
        "Bearer " + storageX.whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_WSO2).get(),
    };
    const keycloakToken = storageX
      .whereKeyIs(STORAGE_KEY_ACCESS_TOKEN_KEYCLOAK)
      .get();
    if (keycloakToken) {
      headers["kc-auth"] = "Bearer " + keycloakToken;
    }
    return headers;
  }

  public amount(): Observable<any> {
    return this.http.get(`${environment.othersUrl.events}/v2/events-panel`, {
      params: {
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      },
      headers: this.buildAuthHeaders(),
    });
  }

  public update(id, payload): Observable<any> {
    return this.http.patch(
      `${environment.othersUrl.events}/v2/events-panel/${id}`,
      payload,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public loadEvents(id, psize = "10", ppage = "0"): Observable<any> {
    return this.http.get(
      `${environment.othersUrl.events}/v2/events-panel/${id}`,
      {
        params: {
          profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
          size: psize,
          page: ppage,
        },
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public loadStatusPneu(payload, IdTerminalAlarme): Observable<any> {
    return this.http.post(
      `${environment.othersUrl.reports}/terminal-status-pneus/`,
      payload,
      {
        headers: this.buildAuthHeaders(),
        params: {
          idTerminalAlarme: IdTerminalAlarme,
        },
      }
    );
  }

  public getCountTerminaisOffline(idPerfil): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/posicao-atual-terminal/perfil/${idPerfil}/offline/count`,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public getCountTerminaisOnline(idPerfil): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/posicao-atual-terminal/perfil/${idPerfil}/online/count`,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public getTerminaisOffline(idPerfil): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/posicao-atual-terminal/perfil/${idPerfil}/offline`,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public getTerminaisOnline(idPerfil): Observable<any> {
    return this.http.get(
      `${environment.apiUrl}/posicao-atual-terminal/perfil/${idPerfil}/online`,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }

  public getTerminaisOnlineAndOffline(
    idPerfil: number | string,
    page = 0,
    size = 10,
    status?: string,
    q?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set("page", String(page))
      .set("size", String(size));

    if (status) {
      params = params.set("status", status);
    }
    if (q) {
      params = params.set("q", q);
    }

    return this.http.get(
      `${environment.apiUrl}/posicao-atual-terminal/perfil/${idPerfil}/online-offline`,
      {
        headers: this.buildAuthHeaders(),
        params,
      }
    );
  }

  public getGridEnderecos(
    idPerfil: number | string,
    itens: Array<{
      idTerminal: number;
      latitude?: string;
      longitude?: string;
    }>
  ): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/posicao-atual-terminal/perfil/${idPerfil}/online-offline/enderecos`,
      itens,
      {
        headers: this.buildAuthHeaders(),
      }
    );
  }
}
